import axios from 'axios';

const exoAxios = axios.create({
  baseURL: `${process.env.REACT_APP_EXO_API_URL}${process.env.REACT_APP_EXO_API_PATH}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

const jsonboxAxios = axios.create({
  baseURL: process.env.REACT_APP_JSONBOX_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// eslint-disable-next-line @typescript-eslint/no-empty-function
const nullErrorHandler = (): void => {};

export { exoAxios, jsonboxAxios, nullErrorHandler };
